<template>
  <div>
    <normal-search
      :advanceSearch.sync="advanceSearch"
      :serverParams="serverParams"
      :searchTypes="searchTypes"
      :options="options"
      @submit="searchShirts()"
      @toggle="productionToggle()"
    />

    <advance-search
      :advanceSearch.sync="advanceSearch"
      :serverParams="serverParams"
      :searchTypes="searchTypes"
      :options="options"
      @submit="searchShirts()"
      @toggle="productionToggle()"
    />

    <div class="grid bg-white">
      <div class="grid-title">
        <h4 class="text-bold">Shirts Production Time Without Shipping</h4>
      </div>

      <div class="grid-body">
        <div class="row">
          <div class="col-md-2">
            <div class="form-group">
              <label for="">Limit Per Scroll</label>
              <select
                class="form-control"
                v-model="serverParams.perPage"
                @change="changeLimit()"
              >
                <option>50</option>
                <option>200</option>
                <option>500</option>
                <option>All</option>
              </select>
            </div>
          </div>
        </div>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>#</th>
              <th @click="sort('id')" class="sort">Order Number</th>
              <th @click="sort('fabric_id')" class="text-center sort">
                Fabric
              </th>
              <th @click="sort('outer_fabric_id')" class="text-center sort">
                C & C Outside
              </th>
              <th @click="sort('inner_fabric_id')" class="text-center sort">
                Contrast
              </th>
              <th
                @click="sort('consultant.first_name')"
                class="text-center sort"
              >
                Consultant
              </th>
              <th @click="sort('client.first_name')" class="text-center sort">
                Client
              </th>
              <th @click="sort('age')" class="text-center sort">Age</th>
              <th
                @click="sort('days_in_current_step')"
                class="text-center sort"
              >
                Days
              </th>
              <th @click="sort('title')" class="text-center sort">Status</th>
              <th @click="sort('date')" class="text-center sort">
                Last Scan Date
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(shirt, index) in shirts" :key="shirt.id">
              <td>{{ index + 1 }}.</td>
              <td class="text-bold">
                <router-link :to="'/shirt/detail/' + shirt.id">
                  {{
                    shirt.type === "male"
                      ? shirt.id
                      : shirt.type === "female"
                      ? "W " + shirt.id
                      : shirt.type === "lady"
                      ? "L " + shirt.id
                      : shirt.id
                  }}
                </router-link>
              </td>
              <td class="text-center">
                <router-link
                  :to="'/fabric/update/' + shirt.fabric_id"
                  v-if="shirt.fabric_id != 0"
                >
                  {{ $Fabric.getCode(shirt.fabric_id) }}
                </router-link>
              </td>
              <td class="text-center">
                <router-link
                  :to="'/fabric/update/' + shirt.outer_fabric_id"
                  v-if="shirt.outer_fabric_id != 0"
                >
                  {{ $Fabric.getCode(shirt.outer_fabric_id) }}
                </router-link>
              </td>
              <td class="text-center">
                <router-link
                  :to="'/fabric/update/' + shirt.inner_fabric_id"
                  v-if="shirt.inner_fabric_id != 0"
                >
                  {{ $Fabric.getCode(shirt.inner_fabric_id) }}
                </router-link>
              </td>
              <td class="text-center">
                <span v-if="shirt.consultant">
                  {{
                    shirt.consultant.first_name +
                    " " +
                    shirt.consultant.last_name
                  }}
                </span>
              </td>
              <td class="text-center">
                <span v-if="shirt.client">
                  {{ shirt.client.first_name + " " + shirt.client.last_name }}
                </span>
              </td>
              <td class="text-center">{{ shirt.age }}</td>
              <td class="text-center">{{ shirt.days_in_current_step }}</td>
              <td class="text-center">{{ shirt.shirt_order_status.title }}</td>
              <td class="text-center">{{ formatDate(shirt.date) }}</td>
            </tr>
            <tr v-if="shirts.length == 0">
              <td colspan="10" class="text-center">No Data</td>
            </tr>
            <tr v-if="noMoreData">
              <td colspan="10" class="text-center">No More Data</td>
            </tr>
            <tr v-if="loading">
              <td colspan="10" class="text-center">
                <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import AdvanceSearch from "./components/AdvanceSearch";
import NormalSearch from "./components/NormalSearch";

export default {
  components: {
    AdvanceSearch,
    NormalSearch,
  },
  data() {
    return {
      shirts: [],
      sortType: "asc",
      serverParams: {
        productionOnly: true,
        columnFilters: [],
        sort: [
          {
            field: "created_at",
            type: "asc",
          },
        ],
        page: 1,
        perPage: 50,
        searchType: "id",
        option: "=",
        keywords: [],
      },
      searchTypes: [
        { column: "id", title: "Order Number", option: "=", keyword: null },
        { column: "fabric_id", title: "Fabric", option: "=", keyword: null },
        {
          column: "collar_fabric_id",
          title: "C & C Outside",
          option: "=",
          keyword: null,
        },
        {
          column: "inner_collar_fabric_id",
          title: "Contrast",
          option: "=",
          keyword: null,
        },
        { column: "age", title: "Age", option: "=", keyword: null },
        {
          column: "days_in_current_step",
          title: "Days In Current Step",
          option: "=",
          keyword: null,
        },
      ],
      options: [
        { value: "=", name: "EQUAL TO" },
        { value: "!=", name: "NOT EQUAL TO" },
        { value: ">", name: "GREATER THAN" },
        { value: "<", name: "LESS THAN" },
      ],
      advanceSearch: false,
      canScroll: false,
      loading: false,
      noMoreData: false,
    };
  },
  mounted() {
    this.getShirts();
    this.scroll();
  },
  methods: {
    search(event) {
      let keyword = event.target.value;
      this.serverParams.columnFilters = [
        { column: "id", option: "=", keyword: [keyword] },
      ];
      this.serverParams.page = 1;
      this.shirts = [];
      this.getShirts();
    },
    async getShirts() {
      this.loading = true;

      let url = `shirt_orders/without_shipping`;
      let serverParams = this.serverParams;
      let res = await axios.post(url, { serverParams: serverParams });
      let data = res.data.data;

      this.shirts.push(...data);

      if (
        data.length < this.serverParams.perPage ||
        this.serverParams.perPage === "All"
      ) {
        this.canScroll = false;
        this.noMoreData = true;
      } else {
        this.canScroll = true;
        this.serverParams.page++;
        this.noMoreData = false;
      }
      this.loading = false;
    },
    formatDate(date) {
      return moment(date).format("DD MMM YYYY");
    },
    scroll() {
      window.onscroll = () => {
        let elem = document.getElementsByClassName("page-content")[0];
        if (this.canScroll === true && this.noMoreData === false) {
          if (
            document.documentElement.scrollTop +
              document.documentElement.offsetHeight >=
            elem.scrollHeight
          ) {
            this.canScroll = false;
            this.getShirts();
          }
        }
      };
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    sort(column) {
      this.sortType = this.sortType === "asc" ? "desc" : "asc";
      if (column === "delivery_date") {
        this.shirts = _.orderBy(
          this.shirts,
          function (shirt) {
            return new Date(_.get(shirt, column));
          },
          [this.sortType]
        );
      } else {
        this.shirts = _.orderBy(
          this.shirts,
          function (shirt) {
            let columnType = "string";
            if (columnType === "numeric") {
              return _.get(shirt, column) || 0;
            } else {
              return _.get(shirt, column) || "";
            }
          },
          [this.sortType]
        );
      }
    },
    changeLimit() {
      this.serverParams.page = 1;
      this.noMoreData = false;
      this.shirts = [];
      this.getShirts();
    },

    searchShirts() {
      let param = {
        columnFilters: {},
        page: 1,
      };
      param.columnFilters = [
        {
          column: this.serverParams.searchType,
          option: this.serverParams.option,
          keyword: this.serverParams.keywords,
        },
      ];
      if (this.advanceSearch) {
        param.columnFilters = this.searchTypes;
      }
      this.shirts = [];
      this.updateParams(param);
      this.getShirts();
    },

    productionToggle() {
      this.shirts = [];
      this.getShirts();
    },
  },
};
</script>

<style scoped>
.fa-spin {
  font-size: 40px;
}
.table thead tr th {
  position: sticky;
  top: 59px;
}
</style>
